import * as React from "react";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { IStoragePathItemData } from "../../../../dataingestion/types/IStoragePathItemData";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { CleanUploadFilesState, addFileToUpload, fileMetadataChanged, setInDropZone, setProgressUploadFileProccess, sortColumn, updatePagination } from "../../../../redux/reducers/DataIngestionReducer";
import { addDroppedFile, cleanDroppedFilesRepertoireState, setEditableFields, setProgressUploadFileRepertoireProccess } from "../../../../redux/reducers/MembersPortalReducer";
import { hideModal, showModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { MembersPortalService } from "../../../../redux/services/MembersPortalService";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { IPaginationDetail } from "../../../../redux/types/IPaginationDetail";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { DataSource } from "../../../../repertoire/types/DataSource";
import { IRemoveWorkBlobAttachment } from "../../../../repertoire/types/IRemoveWorkBlobAttachment";
import { ITreeData } from "../../../../repertoire/types/ITreeData";
import { MY_DRAFT_CUE_SHEET_PAGE, MY_REGISTERED_CUE_SHEET_PAGE, UPLOAD_CUE_SHEETS_PAGE_VIEW } from "../../../Consts";
import { IMembersPortalField } from "../../../types/IMembersPortalField";

import ScrollEventListenerWrapperContainerDetailsWindow from "../../../../dataingestion/components/containerDetailsWindow/ScrollEventListenerWrapperContainerDetailsWindow";

export interface IUploadCueSheetsMaintenanceGeneralDataViewProps {
    UploadCueSheetsMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    usage: IUsageGroupState;
    isReadOnly: boolean;
    lookupValues: ILookupDictionary;
    editableFields: any[];
    resetMessageBanner: () => void;
    changesMade: boolean;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IMembersPortalComponentDataItem;
    dataGridTableEditableFieldsData?: IMembersPortalComponentDataItem;
    setEditableFields?: typeof setEditableFields;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal?: typeof showModal;
    hideModal?: typeof hideModal;
    incrementTempID?: () => void;
    activeHeaderSection?: string;
    isMandatory?: boolean;
    uploadCueSheetsMaintenanceGridsViewData: IMembersPortalComponentDataItem;
    addFileToUpload: typeof addFileToUpload;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    containerDetailsWindowComponentData: IComponentDataItem;
    destinations: ILookupInstance[];    
    droppedFiles: IDroppedFiles;
    isDropZone: boolean;
    selectedFileSystem: IFileSystem;
    setInDropZone: typeof setInDropZone;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    sortColumn: typeof sortColumn;
    storagePathItemData: IComponentDataItem;
    attachedInputFiles: IStoragePathItemData[];
    attachedErrorsFiles: IStoragePathItemData[];
    attachedArchiveFiles: IStoragePathItemData[];
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    removeWorkAttachmentIfExists: (attachedFile: IAttachedFile, source: DataSource) => void;
    addDroppedFileRepertoire?: typeof addDroppedFile;
    workAttachmentsDropped?: IDroppedFiles;
    cleanDroppedFilesRepertoire: typeof cleanDroppedFilesRepertoireState;
    setProgressUploadFileRepertoire: typeof setProgressUploadFileRepertoireProccess;
    refreshWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], activeTabItem: ITabReduxItem, readonlyIndicatorsWorkFlagTypes: string[], formats?: FormatFields[]) => void;
    dataSource: DataSource;
    paginationDetails: IPaginationDetail[];
    updatePagination: typeof updatePagination;
    getDataIngestionComponentData?: () => void;
    currentUserNameNumber: string;   
    setCurrentPage: (link: string) => void;
    addTab: (tab: ITabReduxItem) => void;
}

export default class UploadCueSheetsMaintenanceGeneralDataView extends React.PureComponent<
    IUploadCueSheetsMaintenanceGeneralDataViewProps> {
    viewData;
    constructor(props: IUploadCueSheetsMaintenanceGeneralDataViewProps) {
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "draftWorkWorkProperties",
            loaded: false
        };
        this.viewData = {};
    }

    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    showFieldsModal = () => {

    }
    
    renderGridViewHeaderSections = (header: IMembersPortalField, isMandatory = false) => {
        return (
            <div
                className={["headerSection", "activeSection", (isMandatory ? "isMandatory" : "")].join(" ")}
                key={header.name}
                data-testid={header.name + "-section"}            >
                {header.data}
            </div>
        );
    };

    refreshWorkDetails() {
        const { tabs, activeTab, lookupValues, dataSource } = this.props;
        let currentTab = tabs[activeTab];
        this.props.refreshWorkDetails(
            dataSource,
            currentTab.workMaintenanceState.work.workID,
            lookupValues,
            tabs[activeTab].otherIndicatorWorkFlagTypes,
            currentTab,
            tabs[activeTab].readonlyIndicatorWorkFlagTypes
        )
    }

    removeAttachmentFromMaintenanceScreen(fullName: string, workId: number, dataSource: DataSource, guid: string, index: number) {
        const attachedFile: IAttachedFile = {
            fileName: fullName,
            workId: workId
        }
        const model: IRemoveWorkBlobAttachment = {
            Guid: guid,
            Source: dataSource,
            workID: workId
        }

        MembersPortalService.removeWorkBlobAttachment(model)
            .then(res => {
                if (res) {
                    MembersPortalService.removeWorkAttachment({ attachedFile: attachedFile, dataSource: dataSource })
                        .then((res: boolean) => {
                            if (res) {
                                this.refreshWorkDetails();
                            }
                        })
                }
            })
    }

    renderForm = () => {
        const {
            lookupValues,
            uploadCueSheetsMaintenanceGridsViewData,
            tabs,
            activeTab,
            addFileToUpload,
            cleanUploadFilesState,
            containerDetailsWindowComponentData,
            destinations,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            setInDropZone,
            setProgressUploadFileProccess,
            sortColumn,
            storagePathItemData,
            refreshDirectory,
            addRepertoireAttachmentToState,
            removeWorkAttachmentIfExists,
            addDroppedFileRepertoire,
            workAttachmentsDropped,
            cleanDroppedFilesRepertoire,
            setProgressUploadFileRepertoire,
            paginationDetails,
            updatePagination,
            dataSource,
            currentUserNameNumber
        } = this.props;
        const attachedInputFiles = this.props.attachedInputFiles ?? [];
        const attachedErrorsFiles = this.props.attachedErrorsFiles ?? [];
        const attachedArchiveFiles = this.props.attachedArchiveFiles ?? [];

        const headerRawHtml = uploadCueSheetsMaintenanceGridsViewData.fields.find(
            x => x.name === 'uploadCueSheetsHeader'
        )?.data || '';

        const parts = headerRawHtml.split('[ViewMyDraftCueSheetsLink]').join('[ViewMyRegisteredCueSheetsLink]').split('[ViewMyRegisteredCueSheetsLink]');

        const updatedHeaderHtml = (
            <>
                <span dangerouslySetInnerHTML={{ __html: parts[0] }} />
                <span
                    style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        this.props.setCurrentPage('/products/myDraftCueSheets');
                        this.props.addTab(MY_DRAFT_CUE_SHEET_PAGE);
                    }}
                >
                    View My Draft Cue Sheets
                </span>
                <span dangerouslySetInnerHTML={{ __html: parts[1] }} />
                <span
                    style={{ color: "#007bff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        this.props.setCurrentPage('/products/myRegisteredCueSheets');
                        this.props.addTab(MY_REGISTERED_CUE_SHEET_PAGE);
                    }}
                >
                    View My Registered Cue Sheets
                </span>
                <span dangerouslySetInnerHTML={{ __html: parts[2] }} />
            </>
        );

        return (
            <>
                <div className="topMargin">
                    <div className="uploadCueSheetInstructions" style={{ margin: '0 16px 32px' }}>
                        {updatedHeaderHtml}
                    </div>
                    <br></br>
                </div>
                <div className="headerContainer" style={{flexDirection:'column'}}>
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsUploadSectionHeader'), false)}
                    <div className="uploadCueSheetUploadFile" style={{ padding: '10px 15px', fontWeight: 600 }}>
                        {uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsUploadFile').data}
                    </div>
                </div>
                <br></br>
                {<div className="height">
                    {containerDetailsWindowComponentData.fields.length > 0 && (<ScrollEventListenerWrapperContainerDetailsWindow
                        isUploadCueSheets={true}
                        addFileToUpload={addFileToUpload}
                        cancelChanges={undefined}
                        cleanUploadFilesState={cleanUploadFilesState}
                        containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                        currentDirectory={"usage"}
                        destinations={destinations}
                        editingChanged={undefined}
                        fileMetadataChanged={fileMetadataChanged}
                        jobs={[]}
                        matchNow={undefined}
                        matchNowSubmit={undefined}
                        openDirectory={undefined}
                        pageContentIsActive={true}
                        distributions={undefined}
                        droppedFiles={droppedFiles}
                        isDropZone={isDropZone}
                        selectedFileSystem={selectedFileSystem}
                        setInDropZone={setInDropZone}
                        setProgressUploadFileProccess={setProgressUploadFileProccess}
                        sortColumn={sortColumn}
                        storagePathItemData={storagePathItemData}
                        storagePaths={attachedInputFiles}
                        refreshDirectory={refreshDirectory}
                        saveChanges={undefined}
                        saveState={undefined}
                        isRepertoireModule={true}
                        toggleSidebarCollapsed={undefined}
                        validationMessageChanged={undefined}
                        addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                        entityID={1}
                        entitySource={dataSource}
                        removeAttachmentIfExists={removeWorkAttachmentIfExists}
                        addDroppedFileRepertoire={addDroppedFileRepertoire}
                        attachmentsDropped={workAttachmentsDropped}
                        cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                        setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                        component={UPLOAD_CUE_SHEETS_PAGE_VIEW}
                        removeAttachmentMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
                        displayRemove={false}
                        paginationDetails={paginationDetails}
                        updatePagination={updatePagination}
                        lookupValues={lookupValues}
                        tabs={tabs}
                        activeTab={activeTab}
                        isProductAttachmentTypeNotRequired={true}
                        isProductAttachmentTypeOptional={false}
                        isWorkAttachmentTypeNotRequired={true}
                        isWorkAttachmentTypeOptional={false}
                        currentUserNameNumber={currentUserNameNumber}
                        renderDragFilesUpload={true}
                    />)}
                    <br></br>
                </div>}

                <div className="headerContainer">
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsErrorsSectionHeader'), false)}
                </div>
                <br></br>
                {<div className="height">
                    {containerDetailsWindowComponentData.fields.length > 0 && (<ScrollEventListenerWrapperContainerDetailsWindow
                        isUploadCueSheets={true}
                        addFileToUpload={addFileToUpload}
                        cancelChanges={undefined}
                        cleanUploadFilesState={cleanUploadFilesState}
                        containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                        currentDirectory={"usage"}
                        destinations={destinations}
                        editingChanged={undefined}
                        fileMetadataChanged={fileMetadataChanged}
                        jobs={[]}
                        matchNow={undefined}
                        matchNowSubmit={undefined}
                        openDirectory={undefined}
                        pageContentIsActive={true}
                        distributions={undefined}
                        droppedFiles={droppedFiles}
                        isDropZone={isDropZone}
                        selectedFileSystem={selectedFileSystem}
                        setInDropZone={setInDropZone}
                        setProgressUploadFileProccess={setProgressUploadFileProccess}
                        sortColumn={sortColumn}
                        storagePathItemData={storagePathItemData}
                        storagePaths={attachedErrorsFiles}
                        refreshDirectory={refreshDirectory}
                        saveChanges={undefined}
                        saveState={undefined}
                        isRepertoireModule={true}
                        toggleSidebarCollapsed={undefined}
                        validationMessageChanged={undefined}
                        addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                        entityID={1}
                        entitySource={dataSource}
                        removeAttachmentIfExists={removeWorkAttachmentIfExists}
                        addDroppedFileRepertoire={addDroppedFileRepertoire}
                        attachmentsDropped={workAttachmentsDropped}
                        cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                        setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                        component={UPLOAD_CUE_SHEETS_PAGE_VIEW}
                        removeAttachmentMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
                        displayRemove={false}
                        paginationDetails={paginationDetails}
                        updatePagination={updatePagination}
                        lookupValues={lookupValues}
                        tabs={tabs}
                        activeTab={activeTab}
                        isProductAttachmentTypeNotRequired={true}
                        isProductAttachmentTypeOptional={false}
                        isWorkAttachmentTypeNotRequired={true}
                        isWorkAttachmentTypeOptional={false}
                        currentUserNameNumber={currentUserNameNumber}
                        renderDragFilesUpload={false}
                    />)}
                    <br></br>
                </div>}

                <div className="headerContainer">
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsArchiveSectionHeader'), false)}
                </div>
                <br></br>
                {<div className="height">
                    {containerDetailsWindowComponentData.fields.length > 0 && (<ScrollEventListenerWrapperContainerDetailsWindow
                        isUploadCueSheets={true}
                        addFileToUpload={addFileToUpload}
                        cancelChanges={undefined}
                        cleanUploadFilesState={cleanUploadFilesState}
                        containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                        currentDirectory={"usage"}
                        destinations={destinations}
                        editingChanged={undefined}
                        fileMetadataChanged={fileMetadataChanged}
                        jobs={[]}
                        matchNow={undefined}
                        matchNowSubmit={undefined}
                        openDirectory={undefined}
                        pageContentIsActive={true}
                        distributions={undefined}
                        droppedFiles={droppedFiles}
                        isDropZone={isDropZone}
                        selectedFileSystem={selectedFileSystem}
                        setInDropZone={setInDropZone}
                        setProgressUploadFileProccess={setProgressUploadFileProccess}
                        sortColumn={sortColumn}
                        storagePathItemData={storagePathItemData}
                        storagePaths={attachedArchiveFiles}
                        refreshDirectory={refreshDirectory}
                        saveChanges={undefined}
                        saveState={undefined}
                        isRepertoireModule={true}
                        toggleSidebarCollapsed={undefined}
                        validationMessageChanged={undefined}
                        addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                        entityID={1}
                        entitySource={dataSource}
                        removeAttachmentIfExists={removeWorkAttachmentIfExists}
                        addDroppedFileRepertoire={addDroppedFileRepertoire}
                        attachmentsDropped={workAttachmentsDropped}
                        cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                        setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                        component={UPLOAD_CUE_SHEETS_PAGE_VIEW}
                        removeAttachmentMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
                        displayRemove={false}
                        paginationDetails={paginationDetails}
                        updatePagination={updatePagination}
                        lookupValues={lookupValues}
                        tabs={tabs}
                        activeTab={activeTab}
                        isProductAttachmentTypeNotRequired={true}
                        isProductAttachmentTypeOptional={false}
                        isWorkAttachmentTypeNotRequired={true}
                        isWorkAttachmentTypeOptional={false}
                        currentUserNameNumber={currentUserNameNumber}
                        renderDragFilesUpload={false}
                    />)}
                    <br></br>
                </div>}
            </>
        );
    }

    render() {       
        return this.renderForm();
    }
}